import get from 'lodash/fp/get'
export default {
  computed: {
    isDesignedVr() {
      const app = this.$store.state.app
      return (
        app &&
        app.configuration &&
        app.configuration.company_name === 'DesignedVR'
      )
    },
    isNox() {
      const app = this.$store.state.app
      return (
        app && app.configuration && app.configuration.company_name === 'Nox'
      )
    },
    config() {
      return this.$store.state.app.configuration
    },
    isFeesV2() {
      return get('app.configuration.taxes_v2', this.$store.state)
    },
    ledgerEnabled() {
      return get('app.configuration.ledger_enabled', this.$store.state)
    },
    isChannelManagerOn() {
      return get('app.configuration.is_channel_manager', this.$store.state)
    },
    activePms() {
      return get('app.configuration.active_pms', this.$store.state)
    },
    portalUrl() {
      return get('app.configuration.portal_url', this.$store.state)
    },
    isOptima() {
      return get('app.configuration.active_pms', this.$store.state) === 'optima'
    },
    isHostaway() {
      return (
        get('app.configuration.active_pms', this.$store.state) === 'hostaway'
      )
    },
    isNextpax() {
      return (
        get('app.configuration.cm_type', this.$store.state) === 'nextpax' ||
        get('app.configuration.has_nextpax', this.$store.state)
      )
    },
    isAirbnb() {
      return (
        get('app.configuration.active_pms', this.$store.state) === 'airbnb' ||
        get('app.configuration.has_airbnb', this.$store.state)
      )
    },
    isDemoTenant() {
      const app = this.$store.state.app
      return (
        app && app.configuration && app.configuration.company_name === 'demo'
      )
    },
    isAirbnbDemoTenant() {
      const app = this.$store.state.app
      return app?.configuration?.company_name.includes('Airbnb')
    },
    isAdminTenant() {
      const app = this.$store.state.app
      return (
        app && app.configuration && app.configuration.company_name === 'Admin'
      )
    },
    isBoomRentalsTenant() {
      const app = this.$store.state.app
      return (
        app &&
        app.configuration &&
        app.configuration.company_name === 'BoomRentals'
      )
    },
    isDevelopment() {
      return process.env.NODE_ENV === 'development'
    },
    i18nEnabled() {
      const app = this.$store.state.app
      if (process.env.NODE_ENV === 'production') {
        return (
          app &&
          app.configuration &&
          (app.configuration.company_name === 'Isrentals' ||
            app.configuration.company_name === 'YalaRent')
        )
      } else {
        return true
      }
    },
    isRtl() {
      return this.$vuetify.rtl
    },
    aiDistributionEnabled() {
      const app = this.$store.state.app
      return (
        app &&
        app.configuration &&
        (app.configuration.company_name === 'DesignedVR' ||
          app.configuration.company_name === 'BoomRentals')
      )
    },
    paramsTab: {
      get() {
        return this.$route.params.paramsTab
      },
      set(val) {
        if (
          (!this.$route.params.paramsTab ||
            this.$route.params.paramsTab === ':paramsTab') &&
          val
        ) {
          this.$router.replace({
            params: { ...this.$route.params, paramsTab: val },
          })
        } else if (this.$route.params.paramsTab !== val && val) {
          this.$router.push({
            params: { ...this.$route.params, paramsTab: val || '' },
          })
        }
      },
    },
  },
  methods: {
    openUrl(url, target = '_blank') {
      window.open(url, target)
    },
    addToQuery(query) {
      this.$router.push({
        query: { ...this.$route.query, ...query },
      })
    },
  },
}
